import { shippedCatalogs } from './manifest';

// The one canonical browser-tag → catalog-locale mapping. Resolution is against
// the catalogs actually shipped in this build (not merely the supported set),
// so it can never select a locale whose file doesn't exist: exact match first
// (pt-BR), then primary subtag (fr-CA → fr), then English. English (any region)
// never resolves to a fetch — the in-bundle defaults are the English catalog.
// `shipped` is injectable for tests; production reads the build-time manifest.
export function resolveCatalogLocale(tag: string | undefined | null, shipped: string[] = shippedCatalogs): string {
  if (!tag) {
    return 'en';
  }
  const lower = tag.trim().replace(/_/g, '-').toLowerCase();
  // English regions intentionally never ship a catalog — the in-bundle
  // defaults ARE English — so en-* short-circuits before the shipped check.
  if (lower === 'en' || lower.startsWith('en-')) {
    return 'en';
  }
  for (const locale of shipped) {
    if (locale.toLowerCase() === lower) {
      return locale;
    }
  }
  const primary = lower.split('-')[0];
  for (const locale of shipped) {
    if (locale.toLowerCase() === primary) {
      return locale;
    }
  }
  return 'en';
}
